import BoxUrlOrFile from "@components/BoxUrlOrFile";
import ButtonContainer from "@components/ButtonContainer";
import FileUpload from "@components/Shared/FileUpload";
import FormDatePickerField from "@components/Shared/FormDatePickerField";
import FormTextField from "@components/Shared/FormTextField";
import { timestampToDate } from "@helpers/dates.format";
import IFormProps from "@interfaces/Shared/formProps";
import { IWebinar } from "@interfaces/webinar";
import { ReactElement, useState } from "react";
import { Field } from "react-final-form";

interface IModifyForm extends IFormProps {
  data: IWebinar;
}

const ModifyForm = ({ handleSubmit, data }: IModifyForm): ReactElement => {
  const [date] = useState(timestampToDate(data?.date));

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">Title</span>
        <div className="form__form-group-field">
          <Field
            name="title"
            component={FormTextField}
            type="text"
            placeholder={"Webinar's Title"}
            isAboveError
            initialValue={data?.title}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Date</span>
        <div className="form__form-group-field">
          <Field
            name="date"
            component={FormDatePickerField}
            placeholder="Enter a Date"
            isAboveError
            initialValue={date}
          />
        </div>
      </div>

      <FileUpload
        title="Thumbnail"
        isSingle
        initialData={data}
        formFieldName="thumbnailUrl"
      />

      <BoxUrlOrFile
        title="Media"
        initialValueUrl={data?.mediaUrl}
        section="modify"
        initialData={data}
      />

      <ButtonContainer />
    </form>
  );
};

export default ModifyForm;
